<div id="preview-instructions" class="preview-instructions">
  @if (viewMode === 'PREVIEW') {
    <p class="preview-info">
      Double check for accuracy and then click "Submit" to run the instruction. Or click "Back" to make changes.
    </p>
  }
  @if (viewMode === 'VIEW') {
    <div class="col-12 instruction-transaction-info">
      <div class="col-8" style="padding-left: 1px">
        <span class="preview-label">Next transaction</span>
        <span class="preview-value account" [innerText]="previewData.next === 'TBD' ? 'TBD...' : previewData.next"></span>
      </div>
      @if (showActionButtons) {
        <div class="col-4 instruction-actions-section">
          <instruction-actions [instructionData]="previewData"></instruction-actions>
        </div>
      }
    </div>
  }
  <div class="flex-container">
    <div class="flex-row">
      <div class="flex-col-left preview-label">Account</div>
      <div class="flex-col-middle value">
        <div class="preview-value account" [innerText]="previewData.account | accountNumber"></div>
        <div style="padding-top: 10px">
          <div [innerText]="previewData.accountName" class="preview-account-info"></div>
          <div [innerText]="previewData.accountDescription" class="preview-account-info"></div>
          <div [innerText]="previewData.accountType" class="account-details-type preview-account-info"></div>
        </div>
      </div>
      <div class="flex-col"></div>
    </div>
    <div class="flex-row">
      <div class="flex-col-left preview-label">Transaction Type</div>
      <div class="flex-row-base">
        <div class="preview-value transaction-type" [innerText]="previewData.transactionType"></div>
        <div class="note preview-indicators">
          ({{ previewData.discretionaryInd ? 'Discretionary' : 'Non-Discretionary' }},
          {{ previewData.solicitedInd ? 'Solicited' : 'Unsolicited' }})
        </div>
      </div>
      <div class="flex-col"></div>
    </div>
    <div class="flex-row">
      <div class="flex-col-left preview-label">Mutual Fund</div>
      <div class="flex-col-middle preview-value security" [innerText]="previewData.securityName"></div>
      <div class="flex-col"></div>
    </div>
    <div class="flex-row">
      <div class="flex-col-left preview-label">Amount type</div>
      <div class="flex-col-middle">
        <div class="preview-value amount-type" [innerText]="previewData.amountType"></div>
      </div>
      <div class="flex-col"></div>
    </div>
    <div class="flex-row">
      <div class="flex-col-left preview-label">Amount</div>
      <div class="flex-row-base">
        <div
          class="preview-value amount"
          [innerText]="
            previewData.amountType === 'Dollars' ? (previewData.amount | currency) : (previewData.amount | number: '1.3-3')
          "></div>
        @if (viewMode === 'PREVIEW' || viewMode === 'SUBMITTED') {
          <div class="note preview-indicators">
            {{ transactionFeeMessage }}
          </div>
        }
      </div>
      <div class="flex-col"></div>
    </div>
    <div class="flex-row">
      <div class="flex-col-left preview-label">Frequency</div>
      <div class="flex-col-middle">
        <div class="preview-value frequency" [innerText]="previewData.frequency"></div>
      </div>
      <div class="flex-col"></div>
    </div>
    <div class="flex-row">
      <div class="flex-col-left preview-label">{{ previewData.restartDate ? 'Restart Date' : 'Start Date' }}</div>
      <div class="flex-col-middle">
        <div
          class="preview-value start-date"
        [innerText]="previewData.restartDate ? previewData.restartDate : previewData.startDate"></div>
      </div>
      <div class="flex-col"></div>
    </div>
    <div class="flex-row">
      <div class="flex-col-left preview-label" [innerText]="dayToExecuteLabel"></div>
      <div class="flex-col-middle">
        <div
          class="preview-value start-date"
          [innerText]="
            previewData.dayToExecute2
              ? previewData.dayToExecute + ', ' + previewData.dayToExecute2
              : previewData.dayToExecute
          "></div>
      </div>
      <div class="flex-col"></div>
    </div>
    <div class="flex-row">
      <div class="flex-col-left preview-label">Duration</div>
      <div class="flex-col-middle">
        <div
          class="preview-value duration"
          [innerText]="
            previewData.isRestarted || restartDateExistsAndStopDateIsBeforeRestartDate(previewData)
              ? 'Run until stopped'
              : previewData.duration
          "></div>
      </div>
      <div class="flex-col"></div>
    </div>
    @if (
      !restartDateExistsAndStopDateIsBeforeRestartDate(previewData) && previewData.endDate && !previewData.isRestarted
      ) {
      <div
        class="flex-row"
        >
        <div class="flex-col-left preview-label">Stop Date</div>
        <div class="flex-col-middle">
          <div class="preview-value end-date" [innerText]="previewData.endDate">
            <span class="note"></span>
          </div>
        </div>
        <div class="flex-col"></div>
      </div>
    }
  </div>
</div>
